enum AmountType {
    TASK_CATEGORY = 'task_category',
    MANUAL_AMOUNT = 'manual_amount',
}

export default AmountType;
